import { WideMetricCardProps } from '../../../../components/UI-Elements/WideMetricCard';
import { IRoute } from '../../../../sp-types';
import { IBalanceInstruction } from '../../../../sp-types/balanceFlowType';
import { formatToShortString } from '../../../../utils/FormatValue';

export const getBalanceTransactionApprovalWideCards = (
  materialName: string,
  routeDetails: IRoute,
  balanceInstructions: IBalanceInstruction[],
): WideMetricCardProps[] => {
  const { prices } = routeDetails;
  const { currency, material, shipping, transactionFees } = prices;

  return [
    {
      title: 'Settlement base',
      name: 'settlement',
      unit: materialName,
      quantity: 'Base material',
      color: 'white',
      borderColor: 'gray-100',
    },
    {
      title: 'Fees',
      name: 'transactions',
      unit: '',
      quantity: '',
      color: 'white',
      borderColor: 'gray-100',
      children: (
        <>
          <div>$1/ton service fees</div> <div>$3/ton broker fees</div>
        </>
      ),
    },
    {
      title: 'Flexibility to changes',
      name: 'flexibility',
      unit: 'Before expiration, subject to market conditions, prices and liquidity. Additional changes fees may apply.',
      quantity: 'Anytime',
      color: 'white',
      borderColor: 'gray-100',
    },
    {
      title: 'Additional terms',
      name: 'additionalTerms',
      unit: '',
      quantity: '',
      color: 'white',
      borderColor: 'gray-100',
      children: (
        <ul className="list-disc  text-gray-450 text-sm">
          <li>Quote is finalized only after the customer is sent an execution confirmation certificate.</li>
          <li>Prices do not include taxes &amp; VAT if applicable.</li>
          <li>
            Subject to{' '}
            <a href="#" className="text-blue-600 hover:underline">
              Spotlock’s transaction framework agreement.
            </a>
          </li>
        </ul>
      ),
    },
    {
      title: 'Collateral requirements ',
      name: 'collateral',
      unit: 'Marked to market on a daily basis in accordance with customer’s credit policy.',
      quantity: `$${formatToShortString(
        currency.collateral + material.collateral + shipping.collateral + transactionFees.collateral,
        0,
      )}`,
      color: 'white',
      borderColor: 'gray-100',
    },
  ];
};
